import { render, staticRenderFns } from "./upload-on-phone.vue?vue&type=template&id=2cf4b53e&scoped=true"
import script from "./upload-on-phone.vue?vue&type=script&lang=js"
export * from "./upload-on-phone.vue?vue&type=script&lang=js"
import style0 from "./upload-on-phone.vue?vue&type=style&index=0&id=2cf4b53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4b53e",
  null
  
)

export default component.exports